import { NoSearchResult } from './NoSearchResult'

export const NoContactsFound = ({ className }: { className?: string }) => (
	<NoSearchResult
		className={className}
		lead='Please, change filters or search query to get results'
	/>
)
